export default function NA () {
  return <span class="text-muted">-</span>
}
